"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollerVars = exports.scrollerCommon = exports.default = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _Theme = require("../../themes/Theme");
var _breakpoints = require("../../utils/breakpoints");
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var scrollerCommon = exports.scrollerCommon = [].concat(_toConsumableArray(_commonProps.defaultCommonProps), ["height", "width", "minWidth", "maxWidth", "minHeight", "maxHeight", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "background"]);
var scrollerVars = exports.scrollerVars = (0, _initVars.default)({
  applied: scrollerCommon,
  variables: [{
    key: "shadowColor",
    canHaveColor: true
  }, {
    key: "contentAlign"
  }, {
    key: "scrollBarGap",
    defaultUnit: "px"
  }]
});
var scrollerStyles = function scrollerStyles(theme) {
  return {
    variablesRoot: scrollerVars.styles,
    root: {
      display: "flex",
      alignItems: "center",
      position: "relative",
      width: "fit-content",
      maxWidth: "100%",
      boxSizing: "border-box"
    },
    bar: {
      width: "100%",
      height: "100%",
      display: "flex",
      gap: scrollerVars.get("scrollBarGap", theme.spacing.base),
      alignItems: scrollerVars.get("contentAlign"),
      overflowX: "auto",
      userSelect: "none",
      scrollbarWidth: "none",
      "-ms-overflow-style": "none",
      "&::-webkit-scrollbar": {
        display: "none"
      }
    },
    vertical: {
      flexDirection: "column",
      overflowY: "scroll"
    },
    shadow: {
      position: "absolute",
      pointerEvents: "none",
      opacity: "0",
      transition: "opacity 300ms"
    },
    shadowVisible: {
      opacity: "1"
    },
    start: _defineProperty({
      height: "100%",
      width: theme.spacing.base * 2,
      insetInlineStart: theme.spacing.base * 3 - 1
    }, _breakpoints.HOVER_DISABLED, {
      insetInlineStart: -1
    }),
    startShadow: _defineProperty({}, _breakpoints.HOVER_DISABLED, {
      background: "linear-gradient(to right, transparent, ".concat(scrollerVars.get("shadowColor"), ")")
    }),
    end: _defineProperty({
      height: "100%",
      width: theme.spacing.base * 2,
      insetInlineEnd: theme.spacing.base * 3 - 1
    }, _breakpoints.HOVER_DISABLED, {
      insetInlineEnd: -1
    }),
    endShadow: _defineProperty({}, _breakpoints.HOVER_DISABLED, {
      background: "linear-gradient(to left, transparent, ".concat(scrollerVars.get("shadowColor"), ")")
    }),
    icon: _defineProperty({
      position: "absolute",
      padding: 0,
      height: "100%",
      display: "flex",
      alignItems: "center"
    }, _breakpoints.HOVER_DISABLED, {
      display: "none"
    }),
    iconStart: {
      background: "linear-gradient(to ".concat(theme.direction === _Theme.Direction.ltr ? "left" : "right", ", transparent 0%, ").concat(scrollerVars.get("shadowColor"), " 30%)"),
      insetInlineStart: 0
    },
    iconEnd: {
      background: "linear-gradient(to ".concat(theme.direction === _Theme.Direction.ltr ? "right" : "left", ", transparent 0%, ").concat(scrollerVars.get("shadowColor"), " 30%)"),
      insetInlineEnd: 0
    },
    top: {
      height: theme.spacing.base * 2,
      width: "100%",
      top: 0,
      background: "linear-gradient(".concat(scrollerVars.get("shadowColor"), ", transparent)")
    },
    bottom: {
      height: theme.spacing.base * 2,
      width: "100%",
      bottom: 0,
      background: "linear-gradient(transparent, ".concat(scrollerVars.get("shadowColor"), ")")
    }
  };
};
var useScrollerStyles = (0, _createUseStyles.default)(scrollerStyles, {
  name: "Scroller"
});
var _default = exports.default = useScrollerStyles;